import { StarReview, FlechaReview } from '../../../../assets/icons/Icons'
import '../styles/GoogleReview.css'

const GoogleReview = ({ reviewUrl }) => {
  return (
    <div className="homeout__google-review">
      <div className="homeout__google-review-inner">
        <div className="homeout__google-review-copy">
          <span className="" aria-hidden="true"><StarReview /><StarReview /><StarReview /><StarReview /><StarReview /></span>
          <div>
            <p className="homeout__google-review-title">Queremos conocer cómo fue tu experiencia con nosotros </p>
            <p className="homeout__google-review-subtitle">¡Cuéntanos en Google Reviews!</p>
          </div>
        </div>
        <a
          className="homeout__google-review-link"
          href={reviewUrl}
          target="_blank"
          rel="noreferrer noopener"
        >
          Dejar mi reseña  <span className="google-review-arrow"><FlechaReview /></span>
        </a>
      </div>
    </div>
  )
}

export default GoogleReview
